// src/lib/useAuth.ts
// /api/auth/me を fetch して role を返す薄い hook。
// 既存の AuthGate / AuthHeader と同じ queryKey (["auth", "me"]) を共有するので
// dedupe される (= キャッシュ単発、 1 セッションで /api/auth/me は 1 回しか叩かれない)。
//
// 用途: 主治医関連 UI を canViewDoctor でガードしたい component から呼ぶ。
//   - 未ログイン / loading 中 → canViewDoctor=false (安全側 default)
//   - loaded で is_admin || is_responsible → canViewDoctor=true
import { useQuery } from "@tanstack/react-query";
import { authApi } from "./auth-api";

export interface AuthRole {
  isLoaded: boolean;
  isAdmin: boolean;
  isResponsible: boolean;
  canViewDoctor: boolean;  // = is_admin || is_responsible (= 主治医関連 UI 閲覧可)
  email: string | null;
}

export function useAuth(): AuthRole {
  const { data, isLoading } = useQuery({
    queryKey: ["auth", "me"],
    queryFn: authApi.me,
    retry: false,
    staleTime: 30_000,
  });

  if (isLoading || !data) {
    // ローディング中 / 401 → 安全側で主治医関連 UI 非表示
    return {
      isLoaded: false,
      isAdmin: false,
      isResponsible: false,
      canViewDoctor: false,
      email: null,
    };
  }
  const u = data.user;
  return {
    isLoaded: true,
    isAdmin: !!u.is_admin,
    isResponsible: !!u.is_responsible,
    canViewDoctor: !!u.can_view_doctor,
    email: u.email,
  };
}
